import { Component, ErrorInfo, ReactNode } from 'react';
import styled from '@emotion/styled';
import { isChunkLoadError, reloadOnce } from '@/common/chunkReload';
import { designSystem } from '@/styles/theme';

/**
 * 화면을 그리다 오류가 나도 흰 화면으로 멈추지 않게 받는다(2026-09-27 — 앱 흰 화면 사고).
 * 새 버전 배포로 옛 화면 조각을 못 불러온 경우면 바로 한 번 새로고침하고, 그 밖의 오류는 다시 불러오기 화면을 보여 준다.
 */
interface Props {
    children: ReactNode;
}

interface State {
    error: unknown;
}

class AppErrorBoundary extends Component<Props, State> {
    state: State = { error: null };

    static getDerivedStateFromError(error: unknown): State {
        return { error };
    }

    componentDidCatch(error: unknown, info: ErrorInfo): void {
        console.error('[AppErrorBoundary]', error, info.componentStack);
        if (isChunkLoadError(error)) reloadOnce();
    }

    render() {
        if (!this.state.error) return this.props.children;
        return (
            <Wrap>
                <Title>화면을 불러오지 못했어요</Title>
                <Lead>새 버전으로 바뀌는 중이거나 연결이 잠시 끊겼을 수 있어요.</Lead>
                <Retry type="button" onClick={() => window.location.reload()}>다시 불러오기</Retry>
                <Home type="button" onClick={() => window.location.replace('/')}>홈으로</Home>
            </Wrap>
        );
    }
}

export default AppErrorBoundary;

const Wrap = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 24px;
    text-align: center;
    background: #fff;
`;

const Title = styled.h1`
    margin: 0;
    font-size: 19px;
    font-weight: 700;
    color: #111827;
`;

const Lead = styled.p`
    margin: 0 0 8px;
    font-size: 15px;
    line-height: 1.6;
    color: #4b5563;
    word-break: keep-all;
`;

const Retry = styled.button`
    width: 100%;
    max-width: 280px;
    border: none;
    border-radius: 12px;
    padding: 14px;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    background: ${designSystem.colors.primary};
    cursor: pointer;
`;

const Home = styled.button`
    width: 100%;
    max-width: 280px;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 13px;
    font-size: 15px;
    font-weight: 600;
    color: #374151;
    background: #fff;
    cursor: pointer;
`;
